





















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "PageError" })
export default class PageError extends Vue {
  @Prop({ required: true })
  public readonly error!: Error;
}
